import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperDeliveryQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.delivery(r),
	queryFn: () => n.deliveryDetail(r),
	enabled: i && !!r
});
//#endregion
export { r as useWorkspaceDeveloperDeliveryQuery };
